import Routes from "./Routes";
import { GlobalStyle } from "./styles/GlobalStyles";

function App() {
  return (
   <>
   <GlobalStyle />
   <Routes />
   </>
  );
}

export default App;